import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type { DashboardStats } from '../types/dashboard.types';

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await apiClient<ApiResponse<DashboardStats>>('/dashboard/stats', {
      method: 'GET',
    });
    return response.data;
  },
};
